import { THEME_TYPO_TOKEN } from './theme';

import { GPMotionConfigMap } from '@/features/method-tester/types/gpMotionTypes';
export { THEME_TYPO_TOKEN };
export const VERSION_1 = 'v1.0.0';
export const VERSION_0_3 = 'v0.3.19';
export const JSSDK_VERSION_LIST = [
  { id: '1', key: VERSION_0_3, initialSelected: true },
  { id: '2', key: VERSION_1, initialSelected: false },
];

// GPMotion related methods centralized here
export const GPMOTION_METHODS = [
  'compass',
  'vibrate',
  'gyro',
  'accelerometer',
  'shake',
];

// GPMotion method configuration map
export const GPMOTION_METHOD_CONFIG: GPMotionConfigMap = {
  shake: {
    method: 'listeningShake',
    params: { on: true },
    event: 'motion.shake',
    key: 'shake',
    stopMethod: 'listeningShake',
    stopParams: { on: false },
  },
  gyro: {
    method: 'listenGyro',
    params: { on: true },
    event: 'motion.gyro',
    key: 'gyro',
    stopMethod: 'listenGyro',
    stopParams: { on: false },
  },
  vibrate: {
    method: 'vibrate',
    key: 'vibrate',
  },
  compass: {
    method: 'startCompass',
    event: 'GPMotion.Event.compass',
    key: 'compass',
    stopMethod: 'stopCompass',
  },
  accelerometer: {
    method: 'startAccelerometer',
    event: 'GPMotion.Event.accelerometer',
    key: 'accelerometer',
    stopMethod: 'stopAccelerometer',
  },
};
